import React from 'react';

interface Props {
  fillColor: string;
}

const StoolSoft = ({ fillColor }: Props) => {
  return (
    <svg width='32' height='22' viewBox='0 0 32 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M24.069 9.38888C20.4515 9.38888 15.2665 12.2356 15.6282 14.5872C16.1803 18.1765 21.8985 18.0528 25.8778 16.6913C29.3595 15.5001 33.7157 10.7503 31.304 9.63641C29.9707 9.02057 28.7868 9.89682 27.3248 9.88396C25.9082 9.87151 25.4856 9.38888 24.069 9.38888Z'
        fill={fillColor}
      />
      <path
        d='M9.2373 14.2159C6.92794 14.2159 4.46656 12.0041 5.49927 9.88396C6.10215 8.64626 12.2519 9.01757 13.5783 9.51264C14.3612 9.80488 14.4093 10.4817 14.7841 11.2454C15.387 12.4737 10.6843 14.2159 9.2373 14.2159Z'
        fill={fillColor}
      />
      <path
        d='M14.0606 5.92332C10.574 5.6865 6.31949 2.42783 7.79031 1.22007C8.99614 0.22991 12.2519 0.848755 14.7841 0.972534C17.7627 1.11813 20.8133 0.972362 20.8133 3.44793C20.8133 5.67579 16.9234 6.11777 14.0606 5.92332Z'
        fill={fillColor}
      />
      <path
        d='M5.49927 21.0232C2.84591 20.6042 -0.540982 17.8052 0.0729568 16.4438C0.506771 15.4817 0.989649 15.2902 2.00237 15.0823C3.20811 14.8347 4.10827 15.7229 5.49927 15.8249C8.87552 16.0724 13.166 17.2058 11.7696 19.7856C11.1666 20.8995 7.06682 21.2708 5.49927 21.0232Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default StoolSoft;
